export const folderKeys = {
  all: ['folders'] as const,
  lists: () => [...folderKeys.all, 'list'] as const,
  listWithItems: () => [...folderKeys.lists(), 'items'] as const,
  listSearch: () => [...folderKeys.lists(), 'search'] as const,
  /**
   * 남의 프로필의 공개 폴더 목록. `lists()` 아래에 두지 않는다 — 내 폴더를 만들고 지울 때 무효화하는 범위에
   * 남의 목록이 섞이면 관련 없는 재조회가 나간다.
   */
  users: () => [...folderKeys.all, 'user'] as const,
  details: () => [...folderKeys.all, 'detail'] as const,
  playNext: () => [...folderKeys.all, 'play-next'] as const,
  detail: (id: string) => [...folderKeys.details(), { id }] as const,
} as const;
